<template>
  <div class="space-y-6">
    <div class="flex justify-between items-center">
      <h2 class="text-2xl font-bold text-gray-800">About Company</h2>
      <button
        class="bg-brand-black p-3 rounded-xl text-white cursor-pointer disabled:bg-opacity-10 disabled:cursor-not-allowed"
        @click="handleSave"
        :disabled="isDisabled"
      >
        Save Changes
      </button>
    </div>

    <div>
      <Label for="description">Company Description</Label>
      <QuillEditor v-model:content="aboutInfo.bio" placeholder="Company Bio" contentType="html" class="bg-white" theme="snow" toolbar="full" />
      <!-- <Textarea :rows="15" id="description" v-model="aboutInfo.bio" class="min-h-[200px]" /> -->
      <p class="text-sm text-gray-500 mt-2">
        Give details about your company, your mission and vision, your services and what makes your company stand out.
      </p>
    </div>

    <!-- <div class="bg-brand-primary/10 p-4 rounded-md border border-black" v-if="aboutInfo.bio">
      <h3 class="font-medium text-brand-primary mb-2">Preview</h3>
      <div class="prose max-w-none">
        <p v-for="(paragraph, index) in paragraphs" :key="index" class="mb-4">
          {{ paragraph }}
        </p>
      </div>
    </div> -->
    <Loading :isLoading="isLoading" className="fixed inset-0 bg-[#1B224B]/[.2] flex justify-center items-center" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import Label from '../ui/Label.vue';
import { useStore } from 'vuex';
import Loading from '@/components/Loading.vue';

const store = useStore();
const props = defineProps({ companyDetails: { type: Object } });
const emit = defineEmits(['refreshCompanyProfile']);

const isLoading = ref(false);
const aboutInfo = ref({
  bio: '',
});

// const paragraphs = computed(() => {
//   return aboutInfo.bio.split('\n\n');
// });

const isDisabled = computed(() => {
  return !aboutInfo.value.bio ? true : false;
});

const handleSave = async () => {
  isLoading.value = true;
  const formData = new FormData();
  Object.keys(aboutInfo.value).forEach((key) => {
    const value = aboutInfo.value[key];
    formData.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
  });
  try {
    await store.dispatch('auth/updateUserProfile', formData);
    emit('refreshCompanyProfile');
  } catch (error) {
    console.error('Error saving company info:', error);
  } finally {
    isLoading.value = false;
  }
  // Here you would typically send this data to your backend
};

onMounted(() => {
  isLoading.value = true;
  if (props.companyDetails) {
    const details = props.companyDetails;

    Object.keys(aboutInfo.value).forEach((key) => {
      if (details[key] !== undefined && details[key] !== null) {
        aboutInfo.value[key] = details[key];
      }
    });
  }
  isLoading.value = false;
});
</script>
